import { action, atom } from '@reatom/framework';
import { useCtx } from '@reatom/npm-react';
import { useEffect, useRef } from 'react';
import { Array } from '@blade/std-lib';
export const backButtonStackAtom = atom([], 'backButtonStackAtom');
const addToGlobal = (key, value) => {
    if (typeof window !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window[key] = value;
    }
};
addToGlobal('__BACK_BUTTON_STACK_ATOM', backButtonStackAtom);
export const androidBackButtonClickedAction = action((ctx) => {
    const stack = ctx.get(backButtonStackAtom);
    const lastListener = Array.lastOrUndefined(stack);
    if (lastListener) {
        lastListener();
        return true;
    }
    return false;
}, 'androidBackButtonClickedAction');
export const useBackButton = (listener, { enabled } = { enabled: true }) => {
    const listenerRef = useRef(undefined);
    listenerRef.current = listener;
    const hasListener = !!listener;
    const ctx = useCtx();
    useEffect(() => {
        if (enabled && hasListener) {
            // Keeping single reference
            const listener = () => {
                listenerRef.current?.();
            };
            backButtonStackAtom(ctx, Array.append(listener));
            return () => {
                backButtonStackAtom(ctx, Array.filter((it) => it !== listener));
            };
        }
    }, [ctx, enabled, hasListener]);
};
//# sourceMappingURL=use-back-button.js.map